module.exports = __webpack_public_path__ + "static/media/brand.481f2343.png";